import ChartContainer from '../../../Common/Services/charts/apex-charts/ChartContainer';
import usePeopleStratificationPercentage from './hooks/usePeopleStratificationPercentage';

export const PeopleStratificationPercentage = () => {
    const { chartConfig } = usePeopleStratificationPercentage();

    return (
        <ChartContainer
            title={"Estratificação do Total de Pessoas"}
            options={chartConfig.options}
            series={chartConfig.series}
            type="bar"
            height={450}
        />
    );
};
